import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetReleaseQuery } from "./releasesSlice";
import { Loader } from "../../components/common/Loader/Loader";
import { format } from "date-fns";

const ReleaseNote = () => {
  const params = useParams();
  const { id } = params;
  const { data, isLoading, isSuccess, isError, error } = useGetReleaseQuery(id);

  const [release, setRelease] = useState();

  useEffect(() => {
    if (data) {
      setRelease(data);
    }
  }, [data]);

  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="release-note-container">
      {isLoading && <Loader />}
      {isError && <div>Something Went Wrong: {error.message}</div>}
      {isSuccess && (
        <>
          <div className="note-content">
            <h2 className="version">{release?.version ?? "N/A"}</h2>
            <p className="text-sm">
              Released:{" "}
              {release?.dueDate
                ? format(new Date(release?.dueDate), "MMMM dd, yyyy")
                : "N/A"}
            </p>
            <div className="container">
              {release?.features?.length > 0 && (
                <div id="features-section">
                  <h3 className="section-title">Features</h3>
                  <ul>
                    {release.features.map((feature, index) => (
                      <li key={index}>
                        <p>{feature}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {release?.bugFixes?.length > 0 && (
                <div id="bugfixes-section">
                  <h3 className="section-title">Bugs Fixed</h3>
                  <ul>
                    {release.bugFixes.map((bug, index) => (
                      <li key={index}>
                        <p>{bug}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {release?.enhancements?.length > 0 && (
                <div id="enhancement-section">
                  <h3 className="section-title">Enhancements</h3>
                  <ul>
                    {release.enhancements.map((enhancement, index) => (
                      <li key={index}>
                        <p>{enhancement}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="note-sidebar">
            <div className="quick-links">
              <h6>What's on this page</h6>
              <ul>
                {release?.features?.length > 0 && (
                  <li onClick={() => scrollToSection("features-section")}>
                    Features
                  </li>
                )}
                {release?.bugFixes?.length > 0 && (
                  <li onClick={() => scrollToSection("bugfixes-section")}>
                    Bugs Fixed
                  </li>
                )}
                {release?.enhancements?.length > 0 && (
                  <li onClick={() => scrollToSection("enhancement-section")}>
                    Enhancements
                  </li>
                )}
              </ul>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ReleaseNote;
